<button
    [attr.aum-icon-button]="icon ? true : null"
    [attr.icon]="icon ? icon : null"
    [ngClass]="{ hallow: isHallow, solid: isSolid }"
    (click)="onClick($event)"
    [attr.mat-stroked-button]="isHallow ? true : null"
    [disabled]="disabled"
>
    <ng-content></ng-content>
</button>
